import { useAsync } from 'react-async';

function deferred(promise) {
  return (args) => promise(args[0]);
}

export const useDeferedAsync = promise => useAsync({ deferFn: deferred(promise), onReject: (e) => { throw e; } });
